import { useMemo } from 'react';
import { useModeStore } from '../store/mode-store';

export const useMobile = (): boolean => {
  const { mode } = useModeStore();
  const isFromMobile = useMemo(() => mode === 'mobile', [mode]);
  return isFromMobile;
};
